import { Download, QrCode } from "lucide-react";
import { QRCodeSVG } from "qrcode.react";
import { getAndroidApkDownloadMeta } from "../utils/mobileAppDownload";

export default function MobileAppDownloadCard({ brandName = "Apparify" }) {
  const { url, isConfigured, label } = getAndroidApkDownloadMeta();

  return (
    <section className="border-t border-neutral-200 pt-8 dark:border-neutral-800 lg:border-l lg:border-t-0 lg:pl-10 lg:pt-0">
      <div className="flex items-start justify-between gap-6">
        <div className="min-w-0">
          <p className="text-[11px] font-bold uppercase tracking-[0.28em] text-neutral-400 dark:text-neutral-500">
            Get the App
          </p>
          <h2 className="mt-3 max-w-xs text-xl font-semibold tracking-tight text-neutral-900 dark:text-neutral-50">
            Shop {brandName} on Android.
          </h2>
          <p className="mt-2 max-w-xs text-sm leading-6 text-neutral-500 dark:text-neutral-400">
            Browse products and keep Apparify close wherever you shop.
          </p>
        </div>

        <div className="hidden shrink-0 items-center justify-center sm:flex">
          {isConfigured ? (
            <div className="border border-neutral-200 bg-white p-2 dark:border-neutral-800 dark:bg-neutral-950" aria-label="APK download QR code">
              <QRCodeSVG
                value={url}
                size={82}
                includeMargin
                bgColor="transparent"
                fgColor="currentColor"
              />
            </div>
          ) : (
            <div className="flex h-[100px] w-[100px] flex-col items-center justify-center border border-neutral-200 text-center text-[10px] text-neutral-400 dark:border-neutral-800 dark:text-neutral-500">
              <QrCode size={20} className="mb-1.5" />
              <span>Coming soon</span>
            </div>
          )}
        </div>
      </div>

      <span className="sr-only">
        {isConfigured
          ? "Tap the button to download the APK directly, or scan the QR code if you want to continue on another device."
          : "The APK download button and QR code will appear here as soon as the Android release is available."}
      </span>

      <div className="mt-6">
        {isConfigured ? (
          <a
            href={url}
            download
            className="group inline-flex min-h-11 items-center justify-center gap-3 rounded-full bg-neutral-900 px-5 py-2.5 text-sm font-semibold text-white transition hover:bg-neutral-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-neutral-400 focus-visible:ring-offset-2 dark:bg-neutral-100 dark:text-neutral-900 dark:hover:bg-white dark:focus-visible:ring-neutral-500 dark:focus-visible:ring-offset-neutral-950"
          >
            <Download size={16} />
            <span>{label || "Install on Android"}</span>
          </a>
        ) : (
          <span
            aria-disabled="true"
            className="inline-flex min-h-11 items-center justify-center rounded-full border border-neutral-300 px-5 py-2.5 text-sm font-semibold text-neutral-500 dark:border-neutral-700 dark:text-neutral-400"
          >
            Android release coming soon
          </span>
        )}
      </div>
    </section>
  );
}
